import React, { useState, useEffect } from "react";
import CheckoutPreview from "../components/Checkout-Preview";
import PaymentOptions from "../components/PaymentOptions";

function Checkout() {
 const [isPayementOptionPage, setIsPayementOptionPage] = useState(false);

useEffect(()=>{
 return ()=>{
  setIsPayementOptionPage(false);
 }
},[])

 return (
    isPayementOptionPage ? <PaymentOptions setIsPayementOptionPage={()=>setIsPayementOptionPage(false)} /> : <CheckoutPreview setIsPayementOptionPage={()=>setIsPayementOptionPage(true)} />
 )
}

export default Checkout;
